export default __webpack_public_path__ + "static/media/Steelspirit Helm.5768166e.jpg";